import type { ReactNode } from "react";

export interface MessageBubbleProps {
	readonly children: ReactNode;
	readonly mine?: boolean;
	readonly meta?: ReactNode;
	readonly failedAction?: ReactNode;
	readonly className?: string;
}

/**
 * MessageBubble — chat message bubble. `mine` flips alignment + accent fill.
 * Mirrors the DS message bubble primitive.
 */
export function MessageBubble({
	children,
	mine = false,
	meta,
	failedAction,
	className = "",
}: Readonly<MessageBubbleProps>) {
	return (
		<article
			className={`ds-message-bubble${mine ? " ds-message-bubble--mine" : ""} ${className}`.trim()}
		>
			<p>{children}</p>
			{meta === undefined && failedAction === undefined ? null : (
				<small>
					{meta}
					{failedAction}
				</small>
			)}
		</article>
	);
}
